import { FC } from 'react';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationEllipsis,
} from '.';

export const PaginationBar: FC<{
  page: number;
  totalPages: number;
  showPages: number;
  setPage: (page: number) => void;
}> = ({ page, totalPages, showPages, setPage }) => {
  const previousPages = Math.max(0, page - Math.floor(showPages / 2));
  const nextPages = Math.min(totalPages - 1, page + Math.floor(showPages / 2));

  const previousPagesArray = Array.from({ length: page - previousPages }).map(
    (_, index) => previousPages + index
  );
  const nextPagesArray = Array.from({ length: nextPages - page }).map(
    (_, index) => page + index + 1
  );

  const firstPreviousPage = previousPagesArray[0];
  const lastNextPage = nextPagesArray[nextPagesArray.length - 1];

  return (
    <Pagination className="mb-[48px] mt-[30px]">
      <PaginationContent>
        {page > 0 && (
          <PaginationItem onClick={() => setPage(page - 1)}>
            {'<'}
          </PaginationItem>
        )}
        {firstPreviousPage != null && firstPreviousPage > 0 && (
          <PaginationItem onClick={() => setPage(0)} key={1}>
            1
          </PaginationItem>
        )}
        {firstPreviousPage != null && firstPreviousPage > 1 && (
          <PaginationItem key="previous-ellipsis" onClick={() => setPage(1)}>
            <PaginationEllipsis />
          </PaginationItem>
        )}
        {previousPagesArray.map((pageIndex) => {
          return (
            <PaginationItem
              onClick={() => setPage(pageIndex)}
              key={pageIndex + 1}
            >
              {pageIndex + 1}
            </PaginationItem>
          );
        })}
        <PaginationItem isActive>{page + 1}</PaginationItem>
        {nextPagesArray.map((pageIndex) => {
          return (
            <PaginationItem
              onClick={() => setPage(pageIndex)}
              key={pageIndex + 1}
            >
              {pageIndex + 1}
            </PaginationItem>
          );
        })}
        {lastNextPage != null && lastNextPage < totalPages - 2 && (
          <PaginationItem
            key="next-ellipsis"
            onClick={() => setPage(totalPages - 2)}
          >
            <PaginationEllipsis />
          </PaginationItem>
        )}
        {lastNextPage != null && lastNextPage < totalPages - 1 && (
          <PaginationItem
            onClick={() => setPage(totalPages - 1)}
            key={totalPages}
          >
            {totalPages}
          </PaginationItem>
        )}
        {page < totalPages - 1 && (
          <PaginationItem onClick={() => setPage(page + 1)}>
            {'>'}
          </PaginationItem>
        )}
      </PaginationContent>
    </Pagination>
  );
};
